/**
 * Common methods, props etc for week vue in the yearly and monthly view
 */
export const weekMixin = {
  computed: {
    startDayOfWeek() {
      return new Date(
        this.currentYear,
        this.currentMonth - 1,
        this.startDate
      ).getDay();
    },
    weekDays() {
      let weekArray = [];
      let date = this.startDate;
      let lastDate = new Date(this.currentYear, this.currentMonth, 0).getDate();
      for (let i = this.startDayOfWeek; i < 7; i++) {
        if (date <= lastDate) {
          weekArray.push(date++);
        } else {
          break;
        }
      }
      return weekArray;
    }
  },
  props: {
    currentMonth: Number,
    currentYear: Number,
    startDate: Number
  },
  methods: {
    /**
     *
     * @param {Integer} year
     * @param {Integer} month
     * @param {Integer} date
     */
    fullDate(year, month, date) {
      return this.formatDate({
        dayOfMonth: date,
        month: month - 1,
        year: year
      });
    }
  }
};
